export default class VehicleHistoryController {
  constructor(resource) {
      this._resource = resource
  }

  async getByVehicleId(vehicle_id) {
    return await this._resource(`vehicle_history/${vehicle_id}`).get()
      .then( res => res.body )
  }
}
